import { render, staticRenderFns } from "./TextboxForm.vue?vue&type=template&id=caba3494"
import script from "./TextboxForm.vue?vue&type=script&lang=js"
export * from "./TextboxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports